// extracted by mini-css-extract-plugin
export default {"item":"TextItem_item__A3Prx","name":"TextItem_name__mNAlG","value":"TextItem_value__o-QIL"};